/**
 * Has the user already consent to the latest requested revision (hash)?
 */ const preDecisionGatewayUserConsent = async (param)=>{
    let { revisionHash, getUserDecision } = param;
    const decision = getUserDecision();
    if (decision === false) {
        return false;
    }
    const { revision } = decision;
    return revisionHash === revision ? "consent" : false;
};
export { preDecisionGatewayUserConsent };
